import React from 'react';
import { Form, Card, Button, Dimmer, Progress } from 'semantic-ui-react';
import { TimeInput } from 'semantic-ui-calendar-react';
import I18nTabs from '../I18nTabs';


const Tournament = (props) => {
  const {
    data,
    onChange,
    onSubmit,
    loading,
    onScheduleGenerate,
    onScheduleSave,
    generateScheduleBtnTitle,
    hasGeneratedSchedule,
    scheduleSaveProgess
  } = props;

  
  return (
    <Card fluid>
      <Card.Content>
        <Card.Header>
          Tournament details
        </Card.Header>
        <Card.Meta>
          Begin time, lunch etc... Make sure that everything is filled before creating a schedule.
        </Card.Meta>
        <Card.Description>
          <Dimmer inverted active={loading}/>
          <Form>
            <Form.Group>
              <TimeInput
                width={3}
                required
                name="beginTime"
                label="Begin Time"
                value={data.beginTime}
                iconPosition="left"
                onChange={onChange} />
              <Form.Input
                width={3}
                required
                label='Offset (m)'
                name='timeOffsetInMinutes'
                value={data.timeOffsetInMinutes}
                onChange={onChange} />
              <TimeInput
                width={3}
                name="lunchBeginTime"
                label="Lunch Begin"
                value={data.lunchBeginTime}
                iconPosition="left"
                onChange={onChange} />
              <TimeInput
                width={3}
                name="lunchEndTime"
                label="Lunch End"
                value={data.lunchEndTime}
                iconPosition="left"
                onChange={onChange} />
              <Form.Input
                width={2}
                required
                label='Area'
                name='area'
                value={data.area}
                onChange={onChange} />
              <Form.Input
                width={2}
                required
                label='Sector'
                name='sector'
                value={data.sector}
                onChange={onChange} />
            </Form.Group>
            <I18nTabs
              data={[{
                name: 'i18n_comments',
                value: data.i18n_comments,
                desc: 'Comments to be displayed next to the schedule' }]}
              onChange={onChange}/>
            {/* <div>Increase offset when competition is off schedule. Use it during the competition to tweak the schedule.</div> */}
            {/* <div>Ex 1: Competition is supposed to start 09:00 but is delayed 30 minutes. Set offset to '30'</div> */}
            {/* <div>Ex 2: Competition was supposed to start 10:00 but was delayed 15 minutes and last 10 matches have taken 10 minutes  more than planned. Set offset to '25' (15 + 10)</div> */}
          </Form>
        </Card.Description>
      </Card.Content>
      { !scheduleSaveProgess && <Card.Content extra>
                                  { !data.hasMatches &&
                                    <Button.Group size='mini'>
                                      <Button
                                        content={generateScheduleBtnTitle}
                                        onClick={onScheduleGenerate} />
                                      { hasGeneratedSchedule &&
                                        <Button
                                          content='Save schedule'
                                          onClick={onScheduleSave} />}
                                    </Button.Group>}
                                  <Button positive floated='right' size='mini' content='Save' onClick={onSubmit} />
                                </Card.Content>}
      { scheduleSaveProgess && <Card.Content extra>
                                 <Progress percent={scheduleSaveProgess} progress/>
                               </Card.Content>}
    </Card>
  );
};

export default Tournament;



// WEBPACK FOOTER //
// ./src/private/common/components/Tournament/Tournament.js